<template>
  <div id="public_news">
    <div class="news-box">
      <div class="news-top">
        <span></span>
        <div class="top-l">
          <p>NEWS</p>
          <h3>推荐新闻</h3>
        </div>
        <div class="top-r">
          <i></i>
        </div>
      </div>

      <WtDataList
        v-model="data.list"
        :url="$url.news.list"
        :pageSize="6"
        :search="search"
        :isPage="false"
      >
        <div slot="list" ref="list">
          <div class="news-bottom">
            <ul>
              <li v-for="(item,index) in data.list" :key="index">
                <span>{{dateFormat(item.publish_time,'MM/dd')}}</span>
                <router-link tag="a" :to="{ name: 'newsInfo',query: { id: item.id }}">{{item.title}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </WtDataList>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tags: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      data: {},
      search: {
        tag_id: []
      }
    };
  },
  mounted() {
    this.tags.forEach(element => {
      this.search.tag_id.push(element.id);
    });
  }
};
</script>

<style lang="scss" scoped>
#public_news {
  width: 100%;
  margin-top: 20px;
}
.news-box {
  .news-top {
    position: relative;
    padding-left: 18px;
    display: flex;
    justify-content: space-between;
    text-align: left;
    > span {
      width: 2px;
      // height: 55px;
      height: 100%;
      background-image: linear-gradient(
          0deg,
          #8ec31f 0%,
          #4eb875 10%,
          #2dbadc 20%,
          #258bcc 31%,
          #273d96 43%,
          #944496 50%,
          #bb4695 53%,
          #dc0536 65%,
          #e83a16 76%,
          #fcd475 89%,
          #d7de00 100%
        ),
        linear-gradient(#c12411, #c12411);
      position: absolute;
      left: 0;
      top: 0;
    }
    .top-l {
      > p {
        font-size: 18px;
        font-weight: normal;
        color: #ccc;
      }
      > h3 {
        font-size: 18px;
        font-weight: 500;
        color: #333;
      }
    }
    .top-r {
      padding-right: 25px;
      position: relative;
      // width: 308px;
      > i {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background: url(../../assets/images/more.png) no-repeat;
        background-size: 100% 100%;
        &:hover {
          background: url(../../assets/images/more1.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .news-bottom {
    padding: 30px 0;
    > ul {
      > li {
        list-style: none;
        margin-bottom: 16px;
        font-size: 16px;
        color: #333;
        overflow: hidden; /* 超出部分隐藏 */
        white-space: nowrap;
        /* 不换行 */
        text-overflow: ellipsis;
        text-align: left;
        /* 超出部分省略号显示 */
        cursor: pointer;
        &:hover {
          color: #e83a16;
          > span {
            color: #e83a16;
          }
        }
        > span {
          font-size: 14px;
          color: #999;
          padding-right: 10px;
        }
        > a {
          color:#333333;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/recommend/news.vue